module.exports = __webpack_public_path__ + "img/服装-文胸款式.7e069861.jpg";